export const getAmplarFeatureHighlightsContentfulId = () =>
  import.meta.env.VITE_FEATURE_HIGHLIGHTS_CONTENTFUL_ID_AMPLAR;

export const getMyHealthFeatureHighlightsContentfulId = () =>
  import.meta.env.VITE_FEATURE_HIGHLIGHTS_CONTENTFUL_ID_MY_HEALTH;

export const isPatientPortalDeveloperMode = () =>
  import.meta.env.VITE_TOGGLE_DEVELOPER_FEATURE === 'true';

export const isAccountDeletionDisabled = () =>
  import.meta.env.VITE_DISABLE_ACCOUNT_DELETION === 'true';

export const isOnboardingDisabled = () =>
  import.meta.env.VITE_DISABLE_ONBOARDING === 'true';

export const isMockAppointmentIframeEnabled = () =>
  import.meta.env.VITE_ENABLE_MOCK_APPOINTMENT_IFRAME === 'true';

/**
 * Returns the list of origins permitted as the appointment iframe `src` and
 * as the `event.origin` for inbound `postMessage` events.
 *
 * Configured via `VITE_APPOINTMENT_IFRAME_ALLOWED_ORIGINS` — a
 * comma-separated list of origins, e.g.:
 *   https://bookings.example.com,https://staging.example.com
 *
 * Trailing `/*` (CSP-style) and trailing slashes are stripped so the values
 * can be compared directly against `new URL(src).origin` / `event.origin`.
 */
export const getAppointmentIframeAllowedOrigins = (): string[] => {
  const raw = import.meta.env.VITE_APPOINTMENT_IFRAME_ALLOWED_ORIGINS ?? '';
  return raw
    .split(',')
    .map((o: string) => o.trim().replace(/\/\*$/, '').replace(/\/$/, ''))
    .filter(Boolean);
};
